<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("view") }} Tier Type</div>
      <router-link class="btn-blue" :to="{name:'Tier Types'}">Tier Types {{ $tc("list") }}</router-link>
    </div>
    <div class="all-details-container">
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Tier Type Name:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{tier_type_name}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Tier Type is active:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{tier_type_is_active == 'Y' ? 'Yes' : 'No'}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      submitted: false,
      tier_type_name: "",
      tier_type_is_active: 'Y',
      tier_type_id: null,
    };
  },
   mounted() {
       const {tier_type_id} = this.$route.params;
       if(tier_type_id){
         this.getTierTypeData(tier_type_id) 
      }else{
          this.$router.go(-1)
      }
  },
  methods: {
       getTierTypeData: function(tier_type_id) {
        MasterService.GetTierTypeData({tier_type_id:tier_type_id})
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.tier_type_name = data.Records[0].tier_type_name;
              this.tier_type_is_active = data.Records[0].tier_type_is_active;
              this.tier_type_id = data.Records[0].tier_type_id;
            } else {
              this.$toasted.show(data.message)
            }
          })
          .catch(error => {
            this.$toasted.show(error)
          });
      
    },
    // editTierType() {
    //   this.submitted = true;
    //   this.$validator.validate().then(valid => {
    //     if (valid) {
    //       // let loader = this.$loading.show();

    //       // console.log("JSON.stringify :", JSON.stringify(finalObj));
    //       let payload = {
    //           tier_type_id: this.tier_type_id,
    //         tier_type_name: this.tier_type_name,
    //         tier_type_is_active: this.tier_type_is_active
    //       };
    //       MasterService.EditTierType(payload)
    //         .then(response => {
    //           const { data } = response;
    //           // loader.hide();
    //           if (data && data.status) {
    //             this.$toasted.show(data.message);

    //             this.$router.push({
    //               path: "/master/tier-types"
    //             });
    //           } else {
    //             this.$toasted.show(data.message);
    //           }
    //         })
    //         .catch(this._CatchError);
    //     } else {
    //       this.$toasted.show("Please enter all details");
    //     }
    //   });
    // }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/TierTypeComponents/viewTierType.vue